/**
 * 需求非要让协查状态和来源放一起,将自定义状态转换为1.修复状态和2.修复来源
 */
export const transStatus = (investigationStatus) => {
  let repairSource = 0;
  let lostRepairStatus = 0;
  switch (investigationStatus) {
    case 1:
      lostRepairStatus = 1;
      repairSource = 2
      break;
    case 2:
      lostRepairStatus = 2;
      repairSource = 2
      break;
    case 3:
      lostRepairStatus = 3;
      repairSource = 2
      break;
    case 4:
      lostRepairStatus = 4;
      repairSource = 2
      break;
    case 5:
      lostRepairStatus = 1;
      repairSource = 4
      break;
    case 6:
      lostRepairStatus = 2;
      repairSource = 4
      break;
    case 7:
      lostRepairStatus = 3;
      repairSource = 4
      break;
    case 8:
      lostRepairStatus = 4;
      repairSource = 4
      break;
    case 9:
      lostRepairStatus = 0
      repairSource = 9
      break;
    default:
  }
  return { repairSource, lostRepairStatus }
}
/**
 * 诉中调解和在线调解中搜索中协查状态Option源
 * @type {({valueText: string, value: number}|{valueText: string, value: number}|{valueText: string, value: number}|{valueText: string, value: number}|{valueText: string, value: number})[]}
 */
export const fiterSearch = [
  { valueText: "修复中(自动协查(来源1))", value: 1 },
  { valueText: "修复成功(自动协查(来源1))", value: 2 },
  { valueText: "修复失败(自动协查(来源1))", value: 3 },
  { valueText: "已失效(自动协查(来源1))", value: 4 },
  { valueText: "修复中(自动协查(来源2))", value: 5 },
  { valueText: "修复成功(自动协查(来源2))", value: 6 },
  { valueText: "修复失败(自动协查(来源2))", value: 7 },
  { valueText: "已失效(自动协查(来源2))", value: 8 },
  {
    valueText: "非自动协查来源",
    value: 9
  }
]
/**
 * websocket开始和取消消息
 * @type {{CANCEL_MSG: number, START_MSG: number}}
 */
export const webSocketStatus = {
  START_MSG: '2', //开始
  CANCEL_MSG: '1' //取消
}

//按序号排序
export const sort = (arr, list) => {
  for (let i = 0; i < arr.length; i++) {
    let sortId = list.indexOf(arr[i])
    arr[i].sortId = sortId
  }
  let sortArr = []
  for (let j = 0; j < arr.length - 1; j++) {
    let temp;
    if (arr[j]['sortId'] > arr[j + 1]['sortId']) {
      temp = arr[j]
      arr[j] = arr[j + 1]
      arr[j + 1] = temp
    }
  }
  for (let x = 0; x < arr.length; x++) {
    sortArr.push(arr[x].systemNum)
  }
  return sortArr


}
// TODO 整理菜单
export const menuKey = {
  LCPENDINGMEDIATIONDIVISION: { key: '待调解分案', value: 'lcPendingMediationDivision' },
  PRELITIMEDIATION: { key: '诉前调解', value: 'preLitimediation' },
  PENDINGCLOSEDIVISION: { key: '待结案分案', value: 'pendingCloseDivision' },
  PMCLOSINGREGT: { key: '结案登记', value: 'pmClosingRegt' },
  PMARCHIVE: { key: '归档', value: 'pmArchive' },
  REVOKEMEDIATIONREVIEW: { key: '撤销调解审核(诉前)', value: 'revokeMediationReview' },
  MEDIATIONCOMMUNICATION: { key: '调解沟通', value: 'mediationCommunication' },
  CLOSECASE: { key: '结案', value: 'closeCase' },
  PPREVOKEMEDIATIONREVIEW: { key: '人民调解(诉前)', value: 'pprevokeMediationReview' },
  MEDIATIONONLINE: { key: '在线调解', value: 'mediationOnline' },
  PRELITIMEDIATIONCASEQUERY: { key: '诉前调解案件查询', value: 'preLitimediationCaseQuery' },
  INLITIMEDIATIONCASEQUERY: { key: '诉中调解案件查询', value: 'inLitimediationCaseQuery' },
  NEGOTIATEDREPAY: { key: '协商还款管理', value: 'negotiatedRepay' },
  PEOPLEMEDIATIONMANAGEMENT: { key: '人民调解案件管理', value: 'peopleMediationManagement' },
}

export const getMenuKey = (menuKeyArr = [], filterMenuArr = []) => {
  if (!(Array.isArray(menuKeyArr) && menuKeyArr.length > 0)) {
    return false
  }
  const filter = menuKeyArr.filter((ele) => {
    if (Array.isArray(filterMenuArr) && filterMenuArr.length > 0) {
      return filterMenuArr.includes(ele)
    }
    return ele
  })
  let valueArr = []
  filter.map((ele, index) => {
    valueArr.push(ele.value)
  })
  return valueArr
}

export const filterHasChild = (obj, result = []) => {
  // console.log('obj',obj)
  const { perm, children, path } = obj
  const routerLength = path.split('/')

  if (perm > 0 && routerLength.length <= 5 ) {
    result.push(path)
  }
  if (!!children) {
    for (let key in children) {
      filterHasChild(children[key], result)
    }
  }
  return result
}

/**
 * 返回两个可修改状态，第一个是大部分，第二个是时间，联系人
 * @param type
 * @param isAuto
 * @returns {boolean[]}
 */
export const verify = (type, isAuto) => {
  if (type === 'visit') {
    return [true, true]
  }
  if (type === 'add') {
    return [false, false]
  }
  if (type === 'edit') {
    if (isAuto) {
      return [false, true]
    } else {
      return [false, false]
    }

  }
}
